import { render, staticRenderFns } from "./Block4Creation.vue?vue&type=template&id=382e60f9&scoped=true&"
import script from "./Block4Creation.vue?vue&type=script&lang=js&"
export * from "./Block4Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e60f9",
  null
  
)

export default component.exports